import {createFileRoute, redirect} from '@tanstack/react-router';
import DiagnosticReportRequest from '@/practitioner/views/diagnosticReport/DiagnosticReportRequest';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/(practitioner)/practitioner/diagnostic-report-request')({
  component: DiagnosticReportRequest,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (!context.company?.isTakePhotoEnabledForPractitioner) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
